export const EMPMGMT = "Employee Management";
export const SUPMGMT = "Supplier Management";
export const INVSTOCKMGMT = "Inventory & Stock Management";
export const BILLMGMT = "Billing Management";
export const CUSTOMERMGMT = "Customer Management";
export const CUSTOMERLOYALITY = "Customer Loyality Point";
export const ACTMGMT = "Accounting Management";
export const REPGEN = "Report Generation";
export const HOTELBKNG = "Hotel Booking System";
export const ADVANCEBOOKING = "Advance Room Booking System";
export const BANQUETBOOKING = "Banquet Booking System";
export const MULTISHOP = "Multi-Hotel Enabled";
export const CUSTOMIZEDCONFIG = "Customized Configuration Management";
export const ONLINEHOTELBKNG = "Online Hotel Booking System";
export const EPAYBILLING = "E-Pay Billing System";
export const ROOM_QR_CODE_SYSTEM = "Room Qr Code System";
export const CANCEL_BILL_MANAGEMENT = "Cancel Bill Management";



//Roles
export const ADMINRIGHTS = "Admin Rights";
export const USERVIEW = "User View";
export const USERCREATION = "User Creation";
export const USERUPDATION = "User Update";

export const CUSTVIEW = "Customer View";
export const CUSTLOYALITYVIEW = "Customer Loyality View";

export const CATGVIEW = "Cateogory View";
export const CATGCREATION = "Cateogory Creation";
export const CATGUPDATE = "Cateogory Update";

export const ROOMVIEW = "Room View";
export const ROOMCREATE = "Room Create";
export const ROOMUPDATE = "Room Update";

export const ROOM_PRICE_CREATE = "Room Price Create";
export const ROOM_PRICE_UPDATE = "Room Price Update";
export const ROOM_PRICE_DELETE = "Room Price Delete";

export const BANQUETVIEW = "Banquet View";
export const BANQUETCREATE = "Banquet Create";
export const BANQUETUPDATE = "Banquet Update";

export const BANQUET_PRICE_CREATE = "Banquet Price Create";
export const BANQUET_PRICE_UPDATE = "Banquet Price Update";
export const BANQUET_PRICE_DELETE = "Banquet Price Delete";

export const BOOKINGRIGHTS = "Booking Rights";
export const BOOKINGCANCEL = "Booking Cancel";

export const ACCVIEW = "Accounting View";
export const ACCPASTBALVIEW = "Past Online Balance View";
export const ACCPASTEXPENSEBALVIEW = "Past Expense Balance View";
export const ACCCREATE = "Accounting Create";
export const ACCUPDATE = "Accounting Update";

export const RESTAURANT_SALES = "Restaurant Sales";
